import { AxiosInstance } from 'axios'
import { MediaObject } from '../types'

export type NewsDto = {
  data: Article[]
}

interface TagDto {
  id: number
  attributes: {
    name: string
  }
}

export type Article = {
  id: number
  attributes: {
    title: string
    short_text: string
    image: MediaObject
    tags: {
      data: TagDto[]
    }
    slug: string
    type: 'Our Press' | "Seline's News" | null
    createdAt: string
    updatedAt: string
    publishedAt: string
    publicated_at: string
  }
}

export type GetNewsArgs = {
  locale: string
}

export const getNews = async (client: AxiosInstance, { locale }: GetNewsArgs) => {
  const path = `/news`
  const params = {
    locale,
    sort: ['publicated_at:desc'],
    fields: ['title', 'short_text', 'slug', 'type', 'createdAt', 'updatedAt', 'publishedAt', 'publicated_at'],
    populate: {
      image: {
        fields: ['url', 'previewUrl', 'alternativeText', 'caption'],
      },
      tags: { fields: ['name'] },
    },
  }
  return (await client.get<NewsDto>(path, { params })).data.data
}
